import { getApps } from "./apps.service";
import { getBlogPosts } from "./blog.service";
import { createServiceResult } from "./serviceResult";

export async function getHomepageFeed(options = {}) {
  const [appsResult, postsResult] = await Promise.all([
    getApps({ ...options, limit: 2 }),
    getBlogPosts({ ...options, limit: 3 }),
  ]);
  const featuredApps = appsResult.data.filter((item) => item.featured);

  return createServiceResult({
    data: {
      featuredApps: (featuredApps.length ? featuredApps : appsResult.data).slice(
        0,
        2
      ),
      latestPosts: postsResult.data.slice(0, 3),
    },
    source:
      appsResult.usedFallback || postsResult.usedFallback ? "fallback" : "api",
    error: appsResult.error || postsResult.error || null,
    usedFallback: appsResult.usedFallback || postsResult.usedFallback,
  });
}
